import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { getLookupNganhNghe } from 'api/lookuplistitemApi';
import { SELECT_ITEM_DEFAULT } from 'config';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default class NganhNgheSelect extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
    isMulti: PropTypes.bool,
  };

  state = {
    itemList: [SELECT_ITEM_DEFAULT],
  };

  componentWillMount = async () => {
    const res = await getLookupNganhNghe();
    if (res.success)
      if (this.props.isMulti) {
        this.setState({
          itemList: [
            ...res.data.map((item) => {
              return { value: item._id, label: item.Name, ...item };
            }),
          ],
        });
      } else {
        this.setState({
          itemList: [
            SELECT_ITEM_DEFAULT,
            ...res.data.map((item) => {
              return { value: item._id, label: item.Name, ...item };
            }),
          ],
        });
      }
  };

  render() {
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });
    }

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };
    return (
      <Container>
        <span {...isHidden}>Ngành/Nghề</span>
        <Clearfix {...isHidden} width={8} />
        <div style={{ flex: 1 }}>
          <Select
            isClearable
            placeholder='-- Select --'
            style={{
              flex: 1,
            }}
            closeMenuOnSelect={this.props.isMulti ? false : true}
            isMulti={this.props.isMulti ? this.props.isMulti : false}
            classNamePrefix='react-select-custom'
            options={this.state.itemList}
            {...getFieldProps}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-nganh-nghe/index.js